/** @format */
import React from 'react';

import { displayAsPrice } from 'utils/format';

export const formatValue = ({ facts, krFields = [] }) => {
  if (krFields.includes(facts?.factFieldName)) {
    return displayAsPrice(facts?.value);
  }

  return facts?.value;
};

export const DescriptionElement = ({ descriptionText, paragraphClass }) => {
  const seperatedDesc = descriptionText.split('\n');

  return seperatedDesc.map((paragraph, index) => (
    <p key={index} className={paragraphClass}>
      {paragraph}
    </p>
  ));
};
